import { useOutletContext, useParams } from 'react-router-dom';

import Debug from '@/components/Debug';
import { ENCOUNTER_TYPES, Encounter } from '@/types/encounter';
import Container from '@/ui/components/Container';

import { EncounterPersonDetails } from './components';
import EncounterAppointmentCard from './components/EncounterAppointmentCard';

const EncounterDetailsHome = () => {
  const { encounter } = useOutletContext<{
    encounter: Encounter;
    path: ENCOUNTER_TYPES;
    refetchEncounter: () => void;
  }>();
  const { encounterType } = useParams<{ encounterType: string }>();

  return (
    <Container type="page">
      {encounter.appointment && <EncounterAppointmentCard encounter={encounter} />}
      <EncounterPersonDetails
        billingItem={encounter.billing_item}
        encounterType={encounterType as ENCOUNTER_TYPES}
      />

      <Debug object={{ encounter, encounterType }} />
    </Container>
  );
};

export default EncounterDetailsHome;
